import Line from './line';
import CartesianGrid from './cartesianGrid';
import LineChart from './lineChart';

const Charts = { Line, CartesianGrid, LineChart };

export default Charts;
